const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnCameraOffXs(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.206 123.065h-14.74a2.52 2.52 0 0 1-1.859-.782 2.688 2.688 0 0 1-.773-1.894v-9.149a2.693 2.693 0 0 1 .773-1.9 2.763 2.763 0 0 1 1.86-.781h2.743l1.342-2.045a.987.987 0 0 1 .826-.45h4.912a.989.989 0 0 1 .826.45l1.342 2.044h2.75a2.586 2.586 0 0 1 1.852.78 2.692 2.692 0 0 1 .775 1.9v9.153a2.685 2.685 0 0 1-.774 1.894 2.585 2.585 0 0 1-1.855.78zm-14.743-2.029H506.2a.587.587 0 0 0 .454-.191.658.658 0 0 0 .188-.46v-9.145a.659.659 0 0 0-.189-.461.612.612 0 0 0-.452-.19h-3.277a.989.989 0 0 1-.826-.45l-1.342-2.044h-3.85l-1.342 2.045a.99.99 0 0 1-.826.45h-3.276a.631.631 0 0 0-.454.19.652.652 0 0 0-.188.461v9.146a.649.649 0 0 0 .188.459.658.658 0 0 0 .456.19zm16.376-.649zm-9-.646a4.346 4.346 0 1 1 4.26-4.345 4.307 4.307 0 0 1-4.263 4.345zm0-6.661a2.316 2.316 0 1 0 2.271 2.316 2.3 2.3 0 0 0-2.274-2.316z",
    transform: "translate(-486.834 -102.066)",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 666",
    transform: "translate(3.834 5.667)",
    style: {
      stroke: "#ff3e72",
      strokeLinecap: "round",
      strokeWidth: 2,
      fill: "none"
    },
    d: "M16.332 0 0 16.333"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCameraOffXs);
export default __webpack_public_path__ + "static/media/btn-camera-off-xs.735c339e40f1d2a9cbc9924a7adae161.svg";
export { ForwardRef as ReactComponent };